import {Pipe, PipeTransform} from '@angular/core';
import {NpaLoansFilter} from './npa-loans.filter';
import {Loan} from '../../model/loan.model';

@Pipe({name: 'npaLoans'})
export class NpaLoanFilterPipe implements PipeTransform {
    private readonly npaLoanFilter: NpaLoansFilter;

    constructor(npaLoansFilter: NpaLoansFilter) {
        this.npaLoanFilter = npaLoansFilter;
    }

    transform(loans: Loan[]): Loan[] {
        return loans.filter(this.npaLoanFilter.onFilterApplied);
    }
}

@Pipe({name: 'nonNpaDelayedLoans'})
export class NonNpaDelayedLoanFilterPipe implements PipeTransform {
    private readonly npaLoansFilter: NpaLoansFilter;

    constructor(npaLoansFilter: NpaLoansFilter) {
        this.npaLoansFilter = npaLoansFilter;
    }

    transform(delayedLoans: Loan[]): any {
        return delayedLoans.filter(loan => !this.npaLoansFilter.onFilterApplied(loan));
    }
}
